const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
	listaBloqueada: [],
    listaMotorista: [],
    listaUnidades: [
		{ id: 1, nome: 'ÁGUA BOA' },
		{ id: 3, nome: 'BARRA DO GARÇAS' },
		{ id: 9, nome: 'PORTO ALEGRE DO NORTE' },
		{ id: 60, nome: 'RIO VERDE (SERTÃO)' }
	]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'BLOQUEIO_BASE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'BLOQUEIO_BASE_LISTADO':
            return { 
				...state, 
				lista: action.payload.data,
				listaBloqueada: action.payload.data.filter(item => item.bloqueada)
			};
                      
        default:
            return state;
    }
}
